'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Checkbox } from '@/shared/components/primitives/checkbox';
import { toggleFilterInParams } from '@/features/games/internal/helpers/filter-url-helpers';
import { scrollToTop } from '@/shared/helpers/scroll-to-top';

type FilterCheckboxItemProps = {
  filterType: string;
  value: string;
  label: string;
  count: number;
  checked: boolean;
};

export const FilterCheckboxItem = ({
  filterType,
  value,
  label,
  count,
  checked,
}: FilterCheckboxItemProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleToggle = () => {
    const currentParams = Object.fromEntries(searchParams?.entries() ?? []);
    const newParams = toggleFilterInParams(currentParams, filterType, value);
    const newUrl = `${pathname}?${newParams.toString()}`;
    router.replace(newUrl, { scroll: false });
    scrollToTop();
  };

  return (
    <label className='group hover:text-text-hover flex cursor-pointer items-center gap-2 py-1'>
      <span className='flex-1'>
        {label} <span className='text-text-muted'>({count})</span>
      </span>
      <Checkbox checked={checked} onCheckedChange={handleToggle} />
    </label>
  );
};
